"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_spring_1 = require("react-spring");
var react_popper_1 = require("react-popper");
var index_1 = require("../../index");
var styles_1 = require("./styles");
function Menu(_a) {
    var children = _a.children, _b = _a.placement, placement = _b === void 0 ? "bottom-start" : _b, style = _a.style;
    var _c = index_1.useDropdown(), isMenuOpen = _c.isMenuOpen, triggerButtonRef = _c.triggerButtonRef, menuContainerRef = _c.menuContainerRef;
    var _d = react_1.useState(null), popperElement = _d[0], setPopperElement = _d[1];
    var _e = react_popper_1.usePopper(triggerButtonRef, popperElement, {
        placement: placement,
    }), styles = _e.styles, attributes = _e.attributes;
    var spring = react_spring_1.useTransition(isMenuOpen, null, {
        delay: 1,
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
    });
    if (!isMenuOpen)
        return null;
    return react_dom_1.createPortal(react_1.default.createElement("article", __assign({ ref: setPopperElement, style: __assign(__assign({}, styles.popper), style) }, attributes.popper), spring.map(function (_a) {
        var item = _a.item, key = _a.key, props = _a.props;
        return item ? (react_1.default.createElement(styles_1.MainContainer, { key: key, style: props, ref: menuContainerRef }, children)) : null;
    })), document.body);
}
exports.default = Menu;
//# sourceMappingURL=index.js.map